// extracted by mini-css-extract-plugin
export default {"content":"ConfirmDialog_content__-UOhl","warningIcon":"ConfirmDialog_warningIcon__1kOa8","message":"ConfirmDialog_message__f8qGr"};